<template>
<div>
  <div class="QueryPriceDownload" v-title data-title="水产价格导出图片">
    <div ref="quotationtop" id="quotationtop"></div>
    <!-- 公告start -->
    <!-- <div v-if="notice.title">
      <div ref="noticeId" class="notice-fixed-top notice-fixed-height text-center bc-white" >
        <div v-if="notice.content" class="fc-less fs5 text-left">{{notice.content}}</div>
      </div>
      <div class="notice-fixed-height notice-place-holder">
        <div v-if="notice.content" class="fc-less fs5">{{notice.content}}</div>
      </div>
    </div> -->
    <!-- 公告end -->
    <!-- 顶部广告start -->
    <!-- <template v-for="ta in topAd">
      <van-image
        v-if="ta.url"
        :key="ta.url"
        width="100%"
        fit="cover"
        :src="fileDomain+ta.url"
      >
        <template v-slot:loading>
          图片加载中<van-loading type="spinner" size="20" />
        </template>
      </van-image>
    </template> -->
    <!-- 顶部广告end -->
    <!-- 筛选区域 -->
    <div class="list-search bc-white"
      :style="{top: stickyTop+'px'}"
    >
      <div class="row align-items-center justify-content-around text-left mb5">
        <div class="copy-select text-ellipsis" @click="showPickerAction('cate')">
          {{params.quoteText}}
          <span v-if="!params.quoteText" class="fc-suppl">选择品类</span>
          <div class="copy-arrow"><van-icon name="arrow-down" /></div>
        </div>
        <div class="copy-select text-ellipsis" @click="showAreaAction('area')">
          {{params.provinceText||'全国'}}
          <!-- <span v-if="!params.provinceText" class="fc-suppl">全国</span> -->
          <div class="copy-arrow"><van-icon name="arrow-down" /></div>
        </div>
        <div class="copy-select text-ellipsis" @click="showDateAction('date')">
          {{params.queryDateText}}
          <span v-if="!params.queryDateText" class="fc-suppl">选择时间</span>
          <div class="copy-arrow"><van-icon name="arrow-down" /></div>
        </div>
        <!-- <div v-if="params.quoteType==='1'&&infoList && infoList.length">
          <div class="fs4 font-bold bc-white">库虾信息</div>
          <template v-if="triggerFlag">
            <div v-for="(stock) in infoList" :key="stock.id" class="bc-white" >
              <div class="fs3 fc-title">{{stock.title}}</div>
              <div class="fs3 text-left fc-quotation">{{stock.content}}</div>
            </div>
          </template>
          <div @click="triggerInfo" class="trigger bc-white row align-items-center justify-content-center fc-suppl">
            <svg t="1587200779021" class="icon" :class="triggerFlag?'rotate':''" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="866" width="16" height="16">
              <path d="M916.88036774 678.77853559a53.62653878 53.62653878 0 1 1 48.26388489 95.45523902l-429.01231019 214.50615506a53.62653878 53.62653878 0 0 1-48.26388488 0l-429.01231019-214.50615506a53.62653878 53.62653878 0 0 1 48.26388489-95.45523902L512 880.95058674z m0-482.63884897a53.62653878 53.62653878 0 1 1 48.26388489 95.45523901l-429.01231019 214.50615511a53.62653878 53.62653878 0 0 1-48.26388488 0l-429.01231019-214.50615511a53.62653878 53.62653878 0 1 1 48.26388489-95.45523901L512 398.3117378z"
                p-id="867" fill="#969799">
              </path></svg>
            <span class="pl2">点击{{triggerFlag?'收起':'展开'}}</span>
          </div>
        </div> -->
      </div>
      <van-button @click="back()" class="mt5">返回</van-button>
      <span class="pl1 pr1"></span>
      <van-button @click="exportData()" type="info" class="mt5">导出今日报价excel</van-button>
      <span class="pl1 pr1"></span>
      <van-button :loading="downloading" @click="downloadImg()" type="info" class="mt5">导出查询结果图片zip</van-button>
    </div>
    <!-- 行情信息区域 -->
    <template v-if="marketInfo.length > 0">
      <div class="pl3 pr3 pt5 bc-white text-left" v-for="(mkt, mktindex) in marketInfo" :key="mktindex">
        <div class="text-left fc-red-cus fs2">{{handleUpdateTime(mkt.publishTime).updateTimeStr}}更新</div>
        <div class="market-card">
          <div class="market-title padding2">{{mkt.quotationType.typeName}}</div>
          <div class="market-remark fs3">
            <p class="line" v-for="(rm, rmindex) in mkt.quotationType.remark" :key="rmindex">{{rm}}</p>
          </div>
          <!-- <div class="line"></div> -->
          <table class="market-price text-center">
            <template v-for="(item, iteminex) in mkt.info">
              <tr :key="iteminex">
                <template v-for="(pr, prindex) in item">
                  <th v-if="iteminex===0" :key="prindex">{{pr}}</th>
                  <td v-else :key="prindex">{{pr}}</td>
                </template>
              </tr>
            </template>
          </table>
        </div>
      </div>
    </template>
    <div v-if="!loading && !error && (!total || !records || records.length < 1)"
      class="text-center pb5" style="padding-top: 10vh;">
        <img v-if="params.quoteType==1" width="50%" src="../../assets/empty_1.png">
        <img v-else  width="50%" src="../../assets/empty_2.png">
        <div class="fs2 fc-suppl pt10 pl5 pr5">
          未找到<span class=""> “
            {{params.quoteType==1?'小龙虾':'螃蟹'}}
            {{params.provinceText?'、':''}}{{params.provinceText}}
            {{params.quoteText?'、':''}}{{params.quoteText}}
            {{params.queryDateText?'、':''}}{{params.queryDateText}}
            ”
          </span>相关信息
        </div>
      <div class="pb10 text-center fs4 font-bold" style="padding-top: 5vh;">
        <div class="fc-red-cus">目前已有<span class="pl1 pr1">{{emptyObj.userCount||0}}</span>位商家参与报价，已收录<span class="pl1 pr1">{{emptyObj.quoteCount}}</span>条价格信息</div>
        <div class="fc-default pt1 fs3">如果您也想参与报价</div>
        <div class="fc-default pt1 fs3">请联系微信<span class="pl1 fc-primary">18668006361</span></div>
      </div>
    </div>
    <van-list
      v-if="total>0"
      class="quotation-list-container bc-white"
      v-model="loading"
      :error.sync="error"
      error-text="出错了，点击重新加载"
      :finished="finished"
      :finished-text="records.length > 0 ? '没有更多了' :''"
      @load="loadMore"
    >
    <template  v-for="(item, index) in records" >
      <div
        class="pt4 bc-white quote-download"
        :id="(params.quoteText||'')+'_'+(index)+'_'+(item.belongDate||'')+'_'+(item.name||'')+'_'+(QUOTE_SECTION[item.section]||'')"
        :key="item.userId+'_'+item.belongDate+'_'+(item.section||'')"
      >
        <template v-if="tipIndex === index">
          <!-- 中部广告 -->
          <!-- <template v-for="ma in midAd">
            <van-image
              v-if="ma.url"
              :key="ma.url"
              width="100%"
              fit="cover"
              :src="fileDomain+ma.url"
              class="mt5"
            >
              <template v-slot:loading>
                图片加载中<van-loading type="spinner" size="20" />
              </template>
            </van-image>
          </template>
          <div
            class="mt3 mb3 pt9 pb9 bc-red fc-white fs8">
            以下商家当前暂时未更新{{queryDateString}}日价格
          </div> -->
        </template>
        <Quotation :key="item.userId+''+item.belongDate+item.section" :item="item" :queryDateString="item.belongDate"></Quotation>
      </div>
    </template>
    </van-list>
    <!-- <div @click="refresh" class="refresh bc-primary fs1">
      刷新
    </div> -->
    <!-- <a href="#quotationtop" class="refresh backtop bc-black fs1">
      顶部
    </a> -->
  </div>
    <!-- 备案 -->
  <!-- <div class="copyright bc-copyright">
    <a style="color: #c1c1c1;" target="_blank" href="http://beian.miit.gov.cn">沪ICP备19025713号-1</a>
  </div> -->
  <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="options"
        @cancel="showPicker = false"
        @confirm="confirmPicker"
      />
    </van-popup>
    <van-popup v-model="showArea" position="bottom">
      <van-area
        :value="params.area"
        title="地区选择"
        :columns-num="1"
        :area-list="areaList"
        :columns-placeholder="['全国', '全部', '全部']"
        @cancel="showArea = false"
        @confirm="confirmArea"
      />
    </van-popup>
    <van-popup v-model="showDate" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        @confirm="confirmDate"
        @cancel="showDate = false"
        :max-date="maxDate"
      />
    </van-popup>
  <!-- 图片预览弹框 -->
  <van-popup
    v-model="previewShow"
    position="bottom"
  >
    <div class="pb10 pl2 pr2">
      <van-image
        width="100%"
        height="60vh"
        fit="contain"
        :src="priviewQrcodeUrl"
      >
        <template v-slot:loading>
          图片加载中<van-loading type="spinner" size="20" />
        </template>
      </van-image>
      <van-icon class="mt7"
        @click="previewImage('')"
        :size="36" color="#fff" name="close" />
      <div class="text-center mt10 pb10 fc-white fs10">
        长按图片识别二维码{{isGroup?'进群':'加TA微信'}}
      </div>
    </div>
  </van-popup>
</div>
</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';
import wx from 'weixin-js-sdk';
import JSZip from 'jszip';
// import saveAs from 'FileSaver';
// import { Base64 } from 'js-base64';
import html2canvas from 'html2canvas';
import { QUOTE_SECTION } from '@/uitls/const';
import config from '../../config';
import Quotation from '../../components/Quotation.vue';
import { isIPhoneX, isQYWeixin, isWeixin } from '../../uitls/checkUtil';
import promisify from '../../uitls/promisify';
// import storage from '../../uitls/cacheUtil';
import storage from '../../uitls/cacheUtil';

import {
  sendRequest, quotesQuery, getWxParams, getregion, getquotebottombuttons, quoteadimages, getStockInfoList, getMarketPrice, getMarketVarieties,
} from '../../network/NetworkAccessor';

const shareImage = {
  1: `${window.location.protocol}//${window.location.host}/images/share/longxia.jpg`,
  2: `${window.location.protocol}//${window.location.host}/images/share/pangxie.jpg`,
};
Vue.use(Toast);

const fill0 = str => (str.length > 1 ? str : `0${str}`);
export default Vue.extend({
  name: 'QueryPriceDownload',
  components: { Quotation },
  data() {
    const now = new Date();
    // 晚上7点以后默认选中第二天
    if (now.getHours() >= 19) {
      now.setDate(now.getDate() + 1);
    }
    const month = `${now.getMonth() + 1}`;
    const day = `${now.getDate()}`;
    const today = `${now.getFullYear()}${fill0(month)}${fill0(day)}`;
    return {
      QUOTE_SECTION,
      isWeixin: isWeixin(),
      isQYWeixin: isQYWeixin(),
      maxDate: new Date(),
      isIPhoneX: isIPhoneX(),
      icons: ['balance-o', 'label-o', 'friends-o'],
      previewShow: false,
      priviewQrcodeUrl: '',
      isGroup: false,
      fileDomain: config.FILE_DOMAIN,
      loading: false,
      error: false,
      finished: false,
      size: 999,
      current: 0,
      total: 1,
      pages: 1,
      hasNext: true,
      records: [],
      params: {
        provinceCode: '',
        // quoteType: '',
        queryDate: today,
        queryDateText: `${now.getFullYear()}-${month}-${day}`,
        quoteType: '1',
        quoteText: '小龙虾',
      },
      dicts: {},
      stickyTop: 0,
      companyId: 1,
      options: [],
      clickPicker: '',
      showPicker: false,
      showArea: false,
      showDate: false,
      areaList: {},
      currentDate: new Date(),
      emptyObj: {},
      tipIndex: -1,
      topAd: [], // 广告图片
      midAd: [], // 广告图片
      notice: {},
      btns: [],
      infoList: [],
      triggerFlag: false,
      marketInfo: [],
      downloading: false,
    };
  },
  props: {
    pm: {
      type: String,
      default: null,
    },
  },
  computed: {
    queryDateString() {
      const list = this.params.queryDate.split('');
      const month = `${list[list.length - 4] === '0' ? '' : list[list.length - 4]}${list[list.length - 3]}`;
      const day = `${list[list.length - 2] === '0' ? '' : list[list.length - 2]}${list[list.length - 1]}`;
      return `${month}月${day}`;
    },
  },
  methods: {
    exportData(e = {}) {
      this.$dialog.confirm({
        title: '确认',
        message: '确定立即下载当日报价信息吗？',
      }).then(() => {
        const token = storage.local.get('token') || '';
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = `${config.DOWNLOAD_DOMAIN}/api/quote/report?token=${token}`;
        console.log(link.href);
        // 获取文件名
        // download 属性定义了下载链接的地址而不是跳转路径
        link.setAttribute('download', `今日报价_${this.params.queryDateText}.xlsx`);
        document.body.appendChild(link);
        link.click();
      }).catch(() => {
        // on cancel
      });
    },
    getMarketVarieties() {
      return sendRequest(getMarketVarieties, {}).then((res) => {
        this.options = res || [];
        this.quoteType = this.options[0].value;
        this.quoteText = this.options[0].text;
      });
    },
    downloadImg() {
      // console.log('downloadImg: ', this.$refs);
      // Object.entries(this.$refs).forEach(([key, value]) => {
      //   console.log('downloadImg: ', key, value, value.id);
      //   if (key.includes('download_')) {
      //     this.createImg(key);
      //   }
      // });
      this.$dialog.confirm({
        title: '确认',
        message: `确定导出${this.params.queryDateText}日${this.params.quoteText}报价图片吗？`,
      }).then(() => {
        if (this.downloading) {
          this.$dialog.alert({
            message: '正在导出，请勿重复操作',
          });
          return;
        }
        this.downloading = true;

        try {
          const zip = new JSZip();//* ****创建实例，zip是对象实例
          const fileName = `${this.params.quoteText}_${this.params.queryDateText}_报价图片_${new Date().toLocaleString('zh-cn', { hour12: false })}.zip`;
          const eles = document.querySelectorAll('.quote-download');
          console.log('eles: ', eles);
          eles.forEach(async (value, index) => {
            // console.log('downloadImg: ', value, value.id);
            const dataURL = await this.createImg(value);
            // 对获取的图片base64数据进行处理
            const arr = dataURL.split(',');
            zip.file(`${value.id}.png`, arr[1], { base64: true });// 根据base64数据在压缩包中生成png数据
            // const ziplength = len(zip.files);
            if (index + 1 === eles.length) { // 当所有图片都已经生成打包并保存zip
              zip.generateAsync({ type: 'blob' })
                .then((content) => {
                  // console.log(content);
                  // saveAs(content, fileName);
                  const link = document.createElement('a');
                  link.href = URL.createObjectURL(content);
                  link.download = fileName;
                  link.click();
                  setTimeout(() => {
                    this.downloading = false;
                  }, 500);
                }).catch((error) => {
                  console.error(error);
                  this.downloading = false;
                });
            }
          });
        } catch (error) {
          console.error(error);
          this.downloading = false;
        }
        setTimeout(() => {
          this.downloading = false;
        }, 5000);
      });
    },

    createImg(ele) {
      return new Promise((resolve, reject) => {
        window.scrollY = 0;
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        this.$nextTick().then(() => {
          setTimeout(() => {
            // const windowWidth = window.document.body.scrollWidth;
            // const windowHeight = window.document.body.scrollHeight;
            // const windowScreenWidth = window.screen.width;
            // 解决办法：在生成图片之前 让滚动条高度为0就好
            const html2canvasOptions = {
              allowTaint: true,
              useCORS: false,
              scrollX: 0,
              scrollY: 0,
              // windowWidth,
              // windowHeight,
              dpi: window.devicePixelRatio * 1.2, // 解决图片不清晰问题
              scale: 1.2,
              logging: config.ENV !== 'prod',
              height: ele.clientHeight,
            };
            // if (windowScreenWidth > windowWidth) {
            //   delete html2canvasOptions.windowWidth;
            //   delete html2canvasOptions.windowHeight;
            // }
            console.log('html2canvas start: ', ele.id);
            html2canvas(ele, html2canvasOptions).then((canvas) => {
              // 生成base64图片数据
              const dataUrl = canvas.toDataURL('image/png');
              // console.log('dataUrl: ', dataUrl);
              // eslint-disable-next-line no-unused-expressions
              resolve(dataUrl);
              console.log('html2canvas end------------------: ', ele.id);
            }).catch((error) => {
              console.error(error);
              reject(error);
            });
          }, 0);
        });
      });
    },

    getMarketInfo() {
      sendRequest(getMarketPrice, {
        ...this.params,
      }).then((res) => {
        this.marketInfo = res || [];
      }).catch((e) => {
        console.log(e);
      });
    },
    handleUpdateTime(dateStr) {
      if (!dateStr) {
        return '';
      }
      // eslint-disable-next-line no-underscore-dangle
      const _dateStr = dateStr.replaceAll('-', '/');
      const [year, month, day, hour, min] = new Date(_dateStr).toLocaleString('zh-cn', { hour12: false }).split(/[/ :]/);
      const [currentYear, currentMonth, currentDay] = new Date().toLocaleDateString().split('/');
      let str = `${month}月${day}`;
      // 如果是当天
      if (year === currentYear && month === currentMonth && day === currentDay) {
        str = '今天';
      }
      const updateTimeStr = `${str} ${hour}:${min}`;
      const publishTimeStr = `${year}年${month}月${day}日`;
      return {
        updateTimeStr,
        publishTimeStr,
      };
    },
    showPickerAction(type = '') {
      if (!this.params.quoteType) {
        this.$dialog.alert({
          message: '请先选择品种',
        });
        return;
      }
      if (!this.options || this.options.length < 1) {
        this.getDict();
      }
      this.showPicker = true;
      this.clickPicker = type;
    },
    showAreaAction(type = '') {
      this.getRegion();
      this.showArea = true;
      this.clickPicker = type;
    },
    showDateAction(type = '') {
      this.showDate = true;
      this.clickPicker = type;
    },
    confirmPicker(val = {}) {
      const flag = this.params.quoteType === val.value;
      this.$set(this.params, 'quoteType', val.value);
      this.$set(this.params, 'quoteText', val.value ? val.text : '');
      this.showPicker = false;
      this.clickPicker = '';
      if (!flag) {
        this.changeSelect();
      }
    },
    confirmArea(val = []) {
      const [province = {}] = val;
      const flag = this.params.provinceCode === province.code;
      this.$set(this.params, 'provinceCode', province.code);
      this.$set(this.params, 'provinceText', province.name);
      this.showArea = false;
      this.clickPicker = '';
      if (!flag) {
        this.changeSelect();
      }
    },
    confirmDate(val) {
      console.log(val);
      // const [province = {}] = val;
      let date = {};
      if (val) {
        date = this.formatDate(val);
      }
      const flag = this.params.queryDate === date.value || '';
      this.$set(this.params, 'queryDate', date.value || '');
      this.$set(this.params, 'queryDateText', date.text || '');
      this.showDate = false;
      this.clickPicker = '';
      if (!flag) {
        this.changeSelect();
      }
    },
    formatDate(date) {
      if (!date) {
        return {};
      }
      const month = date.getMonth() + 1;
      const monthStr = month > 9 ? month : `0${month}`;
      const d = date.getDate();
      const dStr = d > 9 ? d : `0${d}`;
      const datestr = `${date.getFullYear()}${monthStr}${dStr}`;
      const text = `${date.getFullYear()}-${month}-${d}`;
      // console.log(datestr);
      return {
        value: datestr,
        text,
      };
    },
    changeSelect() {
      // console.log('changeSelect');
      Toast.loading({
        message: '查询中...',
        forbidClick: true,
        duration: 500,
      });
      this.finished = false;
      this.total = 1;
      this.pages = 1;
      this.current = 0;
      this.hasNext = true;
      this.records = [];
      Promise.all([this.getData(1), this.getMarketInfo()]).then(() => {
        this.$nextTick().then(() => {
          this.$refs.quotationtop.scrollTop = 0;
        });
      });
      // Element.scrollIntoView();
    },
    getDict() {
      this.getMarketVarieties();
      // return sendRequest(quoteDict).then((res = {}) => {
      //   dicts['1'] = (res.crayfish || {}).categories || [];
      //   dicts['1'].unshift({
      //     value: '',
      //     text: '请选择',
      //   });
      //   dicts['2'] = (res.crab || {}).categories || [];
      //   dicts['2'].unshift({
      //     value: '',
      //     text: '请选择',
      //   });
      //   this.options = dicts[this.params.quoteType];
      //   // this.$set(this.dicts, 'quoteType', dicts[this.params.quoteType]);
      // }).catch((e) => {
      //   // this.$dialog.alert({
      //   //   message: e.message,
      //   // });
      // });
    },
    getRegion(pcode = '') {
      if (this.areaList && Object.keys(this.areaList).length > 10) {
        return;
      }
      sendRequest(getregion, { pcode }).then((res = []) => {
        // res.unshift({
        //   code: '',
        //   name: '请选择',
        // });
        // this.$set(this.dicts, 'provinceCode', res);
        const provinceList = {};
        (res || []).forEach((obj) => {
          provinceList[obj.code] = obj.name;
        });
        this.$set(this.areaList, 'province_list', provinceList);
      }).catch((e) => {
        // this.$dialog.alert({
        //   message: e.message,
        // });
      });
    },
    previewImage(url, isGroup) {
      this.previewShow = !this.previewShow;
      this.priviewQrcodeUrl = url.includes('http') ? url : `${this.fileDomain}${url}`;
      this.isGroup = isGroup;
    },
    loadMore() {
      if (this.pages <= this.current) {
        return;
      }
      this.getData(this.current + 1);
    },
    refresh() {
      this.finished = false;
      this.total = 1;
      this.pages = 1;
      this.current = 0;
      this.hasNext = true;
      this.records = [];
      // this.getNoticeShow();
      this.loadMore();
    },
    getData(page = 1, isRefresh) {
      if (!isRefresh && !this.hasNext) {
        return '';
      }
      const params = Object.assign({}, this.params, {
        current: page,
        size: this.size,
        userId: this.companyId,
      });
      this.loading = true;
      if (page === 1) {
        this.tipIndex = -1;
      }
      return sendRequest(quotesQuery, params).then((res = {}) => {
        this.error = false;
        if (!res.total) {
          this.hasNext = false;
          this.finished = true;
          this.total = res.total;
          this.emptyObj = res.records[0] || {};
          return;
        }
        const {
          total = 1, records: _records = [], pages = 1, hasNext = false,
        } = res;
        let index = -1;
        const records = _records.filter(e => !!e.quotes);
        records.map((e, i) => {
          let mobileList = [];
          try {
            mobileList = JSON.parse(e.mobile);
            if (Object.prototype.toString.call(mobileList) !== '[object Array]') {
              mobileList = [{
                mobile: e.mobile,
                name: '',
              }];
            }
          } catch (error) {
            mobileList = [{
              mobile: e.mobile,
              name: '',
            }];
          }
          const quotes = JSON.parse(e.quotes || null) || [];
          if (index < 0) {
            index = quotes && quotes.length > 0 ? -1 : i;
          }
          Object.assign(e, {
            quotes,
            mobileList,
          });
          return e;
        });
        if (page === 1) {
          this.records = records || [];
          if (index > -1 && this.tipIndex < 0) {
            this.tipIndex = index;
          }
        } else if (this.current !== page) {
          if (index > -1 && this.tipIndex < 0) {
            this.tipIndex = index + this.records.length;
          }
          this.records = this.records.concat(records || []);
        }
        this.total = total;
        this.pages = pages;
        this.hasNext = hasNext;
        this.current = page;
        if (!this.hasNext || (records || []).length < this.size
        || this.records.length >= this.total) {
          this.finished = true;
          // this.tipIndex = this.tipIndex > -1 ? this.tipIndex : this.records.length - 1;
        } else {
          this.finished = false;
        }
        // console.log(this.records);
        if (isRefresh) {
          this.$dialog.alert({
            message: '刷新成功',
          });
        }
      }).catch((e) => {
        console.log(e);
        this.error = true;
        this.$dialog.alert({
          message: e.message || '啊哦，出错了',
        });
      }).then(() => {
        this.loading = false;
      });
    },
    go(item = {}) {
      // this.$router.push(`/AD/info/edit/${item.btnLink || ''}`);
      if (item.btnLink.includes('images/')) {
        this.previewImage(item.btnLink, true);
        return;
      }
      window.open(item.btnLink);
    },
    configWx() {
      if (wx) {
        // const wxp = this.$cookies.get('q_wx_p') || '{}';
        sendRequest(getWxParams, {
          url: window.location.href,
          userId: this.companyId,
          source: this.isQYWeixin ? 'qywx' : 'wx',
        }).then((res) => {
          console.log(res, 'res');
          return res || {};
        }).catch((error) => {
          console.log(error, 'error');
          return {};
        }).then((info = {}) => {
          wx.config({
            // debug: storage.local.get('type') === 4, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: info.appId, // 必填，公众号的唯一标识
            timestamp: info.timestamp, // 必填，生成签名的时间戳
            nonceStr: info.noncestr, // 必填，生成签名的随机串
            signature: info.signature, // 必填，签名
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 必填，需要使用的JS接口列表
          });
          wx.ready(() => {
            console.log(wx, 'ready==============');
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            promisify(wx.checkJsApi)({
              jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            }).then((res) => {
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
              const qt = this.params.quoteType || '1';
              promisify(wx.updateAppMessageShareData)({
                title: this.notice.title, // 分享标题
                desc: `每天零点发布各地真实${qt === '1' ? '小龙虾' : '螃蟹'}价格，涨跌一手掌握`, // 分享描述
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: `${shareImage[qt]}`, // 分享图标
              }).then(() => {
                console.log('success......');
              }).catch((error1) => {
                console.log(error1, 'error1-------');
              });
              promisify(wx.updateTimelineShareData)({
                title: `${this.notice.title}，每天零点发布各地真实${qt === '1' ? '小龙虾' : '螃蟹'}价格，涨跌一手掌握`, // 分享描述
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: `${shareImage[qt]}`, // 分享图标
              }).then(() => {
                console.log('success......');
              }).catch((error1) => {
                console.log(error1, 'error1-------');
              });
            }).catch((error) => {
              console.log(error, 'error-------');
            });
          });
          wx.error((error) => {
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            console.log(wx, 'error==============');
          });
        });
      }
    },
    // getNoticeShow() {
    //   return sendRequest(noticeshow, {
    //     type: this.params.quoteType || '1',
    //     queryDate: this.params.queryDate,
    //     userId: this.companyId,
    //   }).then((res) => {
    //     this.notice = res || {};
    //     return res || {};
    //   }).catch(e => ({})).then((r) => {
    //     this.stickyTop = this.$refs.noticeId ? this.$refs.noticeId.offsetHeight : 0;
    //     return r;
    //   });
    // },
    getInventoryShrimpInfo() {
      sendRequest(getStockInfoList, {
        queryDate: this.params.queryDate,
        userId: this.companyId,
        current: 1,
        size: 1,
      }).then((res = {}) => {
        const { records = [] } = res;
        this.infoList = records || [];
      }).catch((e) => {
        this.$dialog.alert({
          message: (e || {}).message,
        });
      });
    },
    getAD() {
      sendRequest(quoteadimages, { type: this.params.quoteType, userId: this.companyId }).then((res) => {
        console.log(res);
        const ads = res || [];
        this.topAd = ads.filter(a => a.position === '1') || []; // 顶部
        this.midAd = ads.filter(a => a.position === '2') || []; // 中间
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: e.message || '啊哦，出错了',
        });
      });
    },
    getBottomButtons() {
      sendRequest(getquotebottombuttons, {
        userId: this.companyId,
      }).then((res) => {
        this.btns = (res || []).filter(b => b.btnLink);
      }).catch((e) => {
        console.log(e);
        // this.$dialog.alert({
        //   message: e.message || '啊哦，出错了',
        // });
      });
    },
    triggerInfo() {
      // this.triggerFlag = !this.triggerFlag;
      this.$router.push(`/stock/list/${this.params.queryDate || ''}`);
    },
    getMarketInfo() {
      sendRequest(getMarketPrice, {
        ...this.params,
      }).then((res) => {
        this.marketInfo = res || [];
      }).catch((e) => {
        console.log(e);
      });
    },
    back() {
      this.$router.replace('/home');
    },
  },
  watch: {
  },
  created() {
    this.params = Object.assign(this.params, JSON.parse(this.pm));
    // this.configWx();
    // this.getDisplaydict();
    // this.getNoticeShow().then(() => {
    //   // this.configWx();
    // });
    this.getBottomButtons();
    this.getAD();
    if (this.params.quoteType === '1') {
      this.getMarketInfo();
      this.getInventoryShrimpInfo();
    }
  },
  mounted() {
    // window.addEventListener('scroll', this.scrollTo);
    // alert(new Date('2022/9/10 22:11:02'));
    // alert(new Date('2022/9/11 22:22:2'));
    // alert(new Date('2022/09/12 22:33:02'));
  },
});
</script>
<style scoped>
  .QueryPriceDownload {
    min-height: 100vh;
    width: 430px;
    margin: 0 auto;
  }
  .quotation-list-container {
    padding: 1px 8px;
  }
  .fc-quotation {
    color: #0e3a5f;
  }
  .item-box {
    position: relative;
    color: #0e3a5f;
    box-shadow: 0px 4px 6px #7d7979;
    border-radius: 16px;
  }
  .guarantee-tag {
    position: absolute;
    right: 15px;
    top: 0;
    /* background-color: #621f70; */
    color: white;
    font-size: 12px;
    padding: 4px 5px 12px;
    background-image: url('../../assets/guarantee_tag.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .price-tag {
    position: absolute;
    left: 0;
    top: 0;
    /* background-color: #b8d0f2; */
    font-size: 14px;
    /* color: #1e67c7; */
    padding-top: 5px;
    padding-right: 10px;
    width: 76px;
    height: 35px;
    background-image: url('../../assets/price_arc.png');
    background-repeat: no-repeat;
    background-size: 100%;
    text-align: center;
    font-weight: 450;
  }
  .line-top {
    border-top: 2px solid #1e67c7;
  }
  .line-bottom {
    border-bottom: 1px solid #e6e1e1;
  }
  .line-left {
    border-left: 1px solid #e6e1e1;
  }
  .item .col {
    padding-top: 2px;
    padding-bottom: 2px;
    padding-left: 1px;
  }
  .refresh {
    position: fixed;
    bottom: 20vh;
    right: 5px;
    width: 36px;
    height: 36px;
    line-height: 36px;
    border-radius: 50%;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.5);
    color: #ffffff;
  }
  .backtop {
    bottom: calc(20vh - 50px);
  }
  /* .quotation-icon {
    width: 30px;
    height: 30px;
  } */
  .notice-fixed-top {
    position: fixed;
    top: 0;
    left: 0;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    z-index: 999;
  }
  .notice-fixed-height {
    padding: 0 5px 2px 5px;
    width: 100%;
    font-size: .8rem;
    /* margin: 0 auto; */
  }
  .notice-place-holder {
    opacity: 0;
  }
  .bottombtn {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: #ece8e8;
    /* padding: 4px; */
    box-shadow: 1px -2px 6px #7d7979;
    z-index: 99999;
  }
  .bottombtn-height {
    height: 46px;
  }
  .bottom-btn {
    line-height: 1;
    font-size: 14px;
  }
  .bottom-btn button {
    margin: 0;
  }
  .fc-suppl {
    color: #1e67c7;
  }
  .bc-title {
    background-color: #1e67c7;
  }
  .bc-tr {
    background-color: #0e3a5f;
  }
  .merchant-name {
    padding-left: 75px;
    padding-right: 61px;
  }
  .fc-red {
    color: #b71831!important;
  }
  .bc-red {
    background-color: #b71831!important;
  }
  .bc-blue {
    background-color: #00bcd4!important;
  }
  .fc-blue {
    color: #00bcd4!important;
  }
  .price-status {
    color: #ffffff;
    border-radius: 4px;
    font-size: 13px;
    text-align: center;
    line-height: 18px;
    width: 19px;
    height: 19px;
  }
  .van-popup {
    background-color: transparent;
  }
  .list-search {
    position: sticky;
    top: 50px;
    left: 0;
    width: 100%;
    z-index: 999;
    /* background-color: #fff; */
    /* box-shadow: 0px 4px 6px #7d7979; */
  }
  .list-search select {
    border: 1px solid #0e3a5f;
    width: 30%;
    height: 26px;
    line-height: 26px;
    font-size: 14px;
  }
  .trigger {
    font-size: 15px;
  }
  .trigger .icon.rotate {
    transform: rotate(180deg);
  }
  .copy-select {
    position: relative;
    border: 1px solid #0e3a5f;
    height: 32px;
    width: 32%;
    line-height: 32px;
    font-size: 14px;
    padding-right: 18px;
    padding-left: 5px;
    border-radius: 4px;
  }
  .copy-arrow {
    position: absolute;
    top: 50%;
    right: 1px;
    transform: translateY(-48%);
  }
  .fc-red-cus {
    color: #e33b4f;
  }
  .market-remark {
    border: 1px solid #ebedf0;
    border-bottom: 0;
  }
   .market-remark p {
    margin: 0;
    padding: 5px;
   }
  .market-title {
    background-color: turquoise;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
  }
  .market-price {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }
  .market-price td,.market-price th {
    border: 1px solid #ebedf0;
  }
</style>
